import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Observable } from 'rxjs';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { EstatusProyecto } from 'src/app/shared/model/proceso/estadoProyecto';
import { ModalAddOportComponent } from './modal-agrega-oportunidad-marketing/modal-agregar-oportunidad.component';
import { OportunidadesListaBase, VistaOportunidades } from '../oportunidades-comun/oportunidades-lista-base';

/** Oportunidades de Marketing: alta, filtro de estado y aviso de vencidas; su plantilla la comparten ODP y líder. */
@Component({
  selector: 'app-oportunidades-marketing',
  standalone: true,
  templateUrl: './oportunidades-marketing.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    NgxMatSelectSearchModule,
  ],
})
export class OportunidadesMarketingComponent extends OportunidadesListaBase {
  readonly vista: VistaOportunidades = {
    variante: 'marketing',
    titulo: 'Administración de Oportunidades Marketing',
    descripcion: 'Gestione el pipeline comercial, filtre por cliente o estado y acceda al seguimiento desde una sola tabla.',
    textoSinResultados: 'Ajuste los filtros o registre una nueva oportunidad desde el botón superior.',
    conAlta: true,
    conFiltroEstatus: true,
  };

  override listaEstatus = EstatusProyecto.getListEstatus();

  protected readonly rutaSeguimiento = 'PROCESO/seguimiento-marketing';

  opVencidas: Proyecto[] = [];
  opPorVencer: Proyecto[] = [];

  private readonly dialog = inject(MatDialog);
  private readonly snackBar = inject(MatSnackBar);

  protected consultaOportunidades(filtro: ConsultaList<Proyecto>): Observable<any> {
    return this.service.getProjectsWithPaginationMarketing(filtro);
  }

  protected override alCargarPagina(): void {
    this.verificarOportunidadesVencidas();
  }

  override openAddProyecto(): void {
    const dialogRef = this.dialog.open(ModalAddOportComponent, {
      width: '1024px',
      panelClass: 'custom-modalbox',
      disableClose: true,
      data: new Proyecto(),
    });
    dialogRef.afterClosed().subscribe(() => {
      this.consultaPagina(this.currentPage);
    });
  }

  verificarOportunidadesVencidas(): void {
    const hoy = new Date();
    const vencidas: Proyecto[] = [];
    const porVencer: Proyecto[] = [];

    this.oportunidades.forEach((oportunidad) => {
      if (!oportunidad.fechaEstimacion) {
        return;
      }
      const fechaEstimacion = new Date(oportunidad.fechaEstimacion);
      const diferenciaDias = (hoy.getTime() - fechaEstimacion.getTime()) / (1000 * 60 * 60 * 24);

      if (diferenciaDias > 0) {
        vencidas.push(oportunidad);
      } else if (diferenciaDias > -7) {
        porVencer.push(oportunidad);
      }
    });

    this.opVencidas = vencidas;
    this.opPorVencer = porVencer;

    if (vencidas.length > 0 || porVencer.length > 0) {
      this.snackBar.dismiss();
      this.snackBar.open(
        `⚠️ ${porVencer.length} por vencer y ${vencidas.length} vencidas`,
        'Ver',
        {
          duration: 12000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['snackbar-warning'],
        }
      );
    }
  }
}
